/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type co_getplato_grid_sales_features_draft_list_Sort = {
    field: co_getplato_grid_sales_features_draft_list_Sort.field;
    direction: co_getplato_grid_sales_features_draft_list_Sort.direction;
};
export namespace co_getplato_grid_sales_features_draft_list_Sort {
    export enum field {
        CREATED_BY = 'CREATED_BY',
        CREATED_AT = 'CREATED_AT',
    }
    export enum direction {
        ASC = 'ASC',
        DESC = 'DESC',
    }
}

